import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { DropdownList } from "react-widgets";
import { ReactComponent as ArrowDown } from "../../assets/elevva-pro-icons/arrowDown.svg";
import { ReactComponent as BirthdayIcon } from "../../assets/elevva-pro-icons/birthday-icon.svg";
import { ReactComponent as DeleteTag } from "../../assets/elevva-pro-icons/delete-tag.svg";
import { ReactComponent as EditIcon } from "../../assets/elevva-pro-icons/edit-icon.svg";
import { ReactComponent as EditTag } from "../../assets/elevva-pro-icons/edit-tag.svg";
import { ReactComponent as ReloadIcon } from "../../assets/elevva-pro-icons/reloadIcon.svg";
import { ReactComponent as SearchInvidual } from "../../assets/elevva-pro-icons/search-individual-table.svg";
import { ReactComponent as SearchIconAlone } from "../../assets/elevva-pro-icons/searchIconAlone.svg";
import { ReactComponent as ArrowLeft } from "../../assets/elevva-pro-icons/table-arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../assets/elevva-pro-icons/table-arrow-right.svg";
import { ReactComponent as TagIcon } from "../../assets/elevva-pro-icons/tag-icon.svg";

import moment from "moment";
import {
  ButtonArrow,
  ButtonMob,
  instance,
  instanceMob,
  laptop1600,
  laptopMax1350,
} from "../../utils/utils";
import DateInputStart from "./date-input-start";
import UserDetailComponent from "./user-detail";
import PreRegisterUserModal from "./pre-register-user-modal";
import InlineModal from "../info-modal/infoModal";

const UserAdmin = (props) => {
  const [users, setUsers] = useState([]);
  const [selectFilterTag, setSelectFilterTag] = useState(null);
  const [tags, setTags] = useState([]);
  const [detailCompany, setDetailCompany] = useState(null);
  const [tagsSelected, setTagsSelected] = useState([]);
  const [pageNext, setPageNext] = useState(null);
  const [pageBack, setPageBack] = useState(null);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [dataBackup, setDataBackup] = useState({});
  const [modal, setModal] = useState(null);
  const [modalNewUser, setModalNewUser] = useState(null);
  const [modalFilters, setModalFilters] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [displayCorrect, setDisplayCorrect] = useState(null);
  const [ErroraGregado, seterroraGregado] = useState(null);
  const [ErroraGregadoCreateUser, seterroraGregadoCreateUser] = useState(null);
  const [confirm, setModalConfirm] = useState(null);
  const [userSelected, setUserSelected] = useState([]);
  const [userDetail, setUserDetail] = useState(null);
  const [stepUser, setStepUser] = useState(1);
  const [userTriage, setUserTriage] = useState(null);
  const [totalMemberships, settotalMemberships] = useState(null);
  const [planesMob, setPlanesMob] = useState(null);
  const [imageBase64User, setImageBase64User] = useState(null);
  const [loaderNewUser, setLoaderNewUser] = useState(false);
  const [filterUserActive, setFilterUserActive] = useState("True");
  const [optionFilter, setOptionFilter] = useState("");
  const [showModalPreRegister, setShowModalPreRegister] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  function getPlansMob() {
    instanceMob
      .get(`admin/plan/preregister/list`)
      .then((res) => res.data)
      .then((data) => {
        setPlanesMob(data);
      })
      .catch((err) => console.error(err));
  }
  useEffect(() => {
    if (stepUser === 2) {
      function getTriage() {
        instance
          .get(`memberships/corp/company/members/${userDetail.user_id}/triage`)
          .then((res) => res.data)
          .then((data) => {
            setUserTriage(data);
          })
          .catch((err) => console.error(err));
      }
      getTriage();

      function toDataURL(url, callback) {
        const img = new Image(); // Dynamically create the img element
        img.crossOrigin = "Anonymous"; // Enable CORS for the image
        img.onload = function () {
          const canvas = document.createElement("canvas"); // Create a canvas element
          const ctx = canvas.getContext("2d");

          const diameter = Math.min(img.width, img.height);
          const radius = diameter / 2;

          // Configurar el canvas
          canvas.width = diameter;
          canvas.height = diameter;

          // Dibujar un círculo
          ctx.beginPath();
          ctx.arc(radius, radius, radius, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.clip();

          // Dibujar la imagen
          ctx.drawImage(
            img,
            (img.width - diameter) / 2,
            (img.height - diameter) / 2,
            diameter,
            diameter,
            0,
            0,
            diameter,
            diameter
          );

          const dataURL = canvas.toDataURL("image/png"); // Convert canvas to Base64
          callback(dataURL); // Pass the Base64 string to the callback
        };
        img.onerror = function () {
          console.error(
            "Failed to load the image. Check the URL or CORS policy."
          );
        };
        img.src = url; // Set the image source
      }
      if (userDetail.profile_pic) {
        toDataURL(userDetail.profile_pic, function (dataUrl) {
          setImageBase64User(dataUrl);
        });
      }
    }
    getPlansMob();
  }, [stepUser]);
  useEffect(() => {
    if (modalNewUser) handleNewUser();
  }, [loaderNewUser]);
  useEffect(() => {
    if (modalNewUser && ErroraGregadoCreateUser == "" && modalNewUser)
      handleNewUser();
    if (ErroraGregadoCreateUser && modalNewUser) handleNewUser();
  }, [ErroraGregadoCreateUser]);
  useEffect(() => {
    if (ErroraGregado) handlerTags();
  }, [ErroraGregado]);
  useEffect(() => {
    if (tagsSelected.length > 0) handlerTags();
  }, [tagsSelected]);
  useEffect(() => {
    if (modal && tags) handlerTags();
  }, [tags]);
  // &tags=13  TODO
  function handlerFilterByTag(idTag) {
    setSelectFilterTag(idTag);
    instance
      .get(
        `memberships/corp/company/members?active=${filterUserActive}&tags=${idTag}`
      )
      .then((res) => res.data)
      .then((data) => {
        setUsers(data.results);
        setPageNext(data.next);
        setPageBack(data.previous);
        setCount(data.count);
        setModalFilters(null);
      })
      .catch((err) => console.error(err));
  }
  function getUsers(filter = "") {
    setSelectFilterTag(null);
    let filtered = filter.length > 0 ? `${filter}` : "";
    instance
      .get(
        `memberships/corp/company/members?${filtered}&active=${filterUserActive}`
      )
      .then((res) => res.data)
      .then((data) => {
        setUsers(data.results);
        setCount(data.count);
        setPageNext(data.next);
        setPageBack(data.previous);
        setDataBackup(data);
      })
      .catch((err) => console.error(err));
  }
  function showBirthDay() {
    setOptionFilter("birthday");
    getUsers("next-to-birthday=true");
  }
  function getUsersFilter(value) {
    instance
      .get(
        `memberships/corp/company/members?search=${value}&active=${filterUserActive}`
      )
      .then((res) => res.data)
      .then((data) => {
        setUsers(data.results);
        setPageNext(data.next);
        setPageBack(data.previous);
        setCount(data.count);
      })
      .catch((err) => console.error(err));
  }
  function getUsersPage(value) {
    let url = value
      ? value
      : `memberships/corp/company/members?active=${filterUserActive}`;

    instance
      .get(url)
      .then((res) => res.data)
      .then((data) => {
        setUsers(data.results);
        setPageNext(data.next);
        setPageBack(data.previous);
      })
      .catch((err) => console.error(err));
  }
  function getTags() {
    instance
      .get("memberships/corp/tags")
      .then((res) => res.data)
      .then((data) => {
        setTags(data.results);
      })
      .catch((err) => console.error(err));
  }
  function updateFilterTag(e) {
    instance
      .get(`memberships/corp/tags?search=${e.target.value}`)
      .then((res) => res.data)
      .then((data) => {
        setTags(data.results);
      })
      .catch((err) => console.error(err));
  }
  function filtersUser() {
    let styleModal = {
      display: "flex",
      position: "absolute",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModalFilters(
      <div
        className="popUpFiltersAdmin justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 3%",
          }}
        >
          {/* <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModalFilters(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div> */}
          <div
            className=" mb-3 p-1"
            style={{
              lineHeight: "120%",
              textAlign: "center",

              minWidth: "calc(10rem + 1vmin)",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            <PerfectScrollbar
              style={{ maxHeight: "15rem", padding: "0 0.5rem" }}
            >
              {tags.map((tag, i) => (
                <div
                  onClick={() => handlerFilterByTag(tag.id)}
                  className="d-flex py-2 cursor-pointer"
                  key={i}
                  style={{
                    borderBottom: "1px solid #9DACBD",
                    justifyContent: "flex-start",
                    minWidth: "10rem",
                  }}
                >
                  <label className="custom-checkbox me-2">
                    <input
                      type="radio"
                      name="user"
                      checked={selectFilterTag && selectFilterTag === tag.id}
                      onClick={() => { }}
                    />
                    <span className="checkmark"></span>
                  </label>{" "}
                  <span style={{ fontSize: "calc(0.4rem + 0.4vw)" }}>
                    {tag.name}
                  </span>
                </div>
              ))}
            </PerfectScrollbar>
          </div>
        </div>
      </div>
    );
  }
  function assingNewTag(event) {
    let vectorUsers = userSelected;

    let sender_string =
      vectorUsers.length === 1 ? userSelected[0] : userSelected.join(",");
    let tags_strings =
      tagsSelected.length === 1 ? tagsSelected[0] : tagsSelected.join(",");

    let formData = new FormData();
    formData.append("users_id", sender_string);
    formData.append("tags_id", tags_strings);

    instance
      .post(`memberships/corp/tags/assign`, formData)
      .then((res) => {
        if (res.data) {
          let styleModal = {
            display: "flex",
            position: "fixed",
            zIndex: 999,
            whiteSpace: "pre-line",
          };
          getUsers();
          setTagsSelected([]);

          setModal(
            <div
              className="popUpNewUser justify-content-center align-items-center"
              style={styleModal}
            >
              <div
                className="modalInfoContenido"
                style={{
                  background: "white",
                  borderRadius: "20px",
                  boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                  padding: "2% 6%",
                }}
              >
                <div
                  className=""
                  style={{
                    position: "absolute",
                    top: "5%",
                    right: "1%",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    color: " #9DACBD",
                    cursor: "pointer",
                  }}
                  onClick={() => setModal(null)}
                >
                  <i className="bi bi-x-circle"></i>
                </div>
                <div
                  className=" mb-3 py-3"
                  style={{
                    lineHeight: "120%",
                    textAlign: "center",

                    minWidth: "calc(18rem + 1vmin)",

                    color: "var(--elevvabutonLogin_User)",
                  }}
                >
                  <br />
                  asignado(s)
                  <br />
                  <strong>correctamente.</strong>
                  <br />
                </div>
                <form id="form-teepassword-change" onSubmit={hideModal}>
                  <div className="col-12">
                    <div className="col-12 btnAction_pruebas letraspopfi2">
                      <ButtonMob
                        colorButton={"var(--elevvabutonLogin_User)"}
                        text="Confirmar"
                        className={"mb-3 mt-3 letraspopfi2actualizar"}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          );
        }
      })
      .catch((err) => {
        let msg_error = err.response.data;
        if (msg_error) {
          seterroraGregado(msg_error);

          setDisplayCorrect("flex");
          setTimeout(() => {
            setDisplayCorrect("none");
          }, 5000);
        }
      });

    event.preventDefault();
  }
  function createNewTag(event) {
    let value = event.target[0].value;

    var formData = new FormData();
    formData.append("name", value.trim());

    instance
      .post(`memberships/corp/tags/`, formData)
      .then((res) => {
        if (res.data) {
          getTags();

          let styleModal = {
            display: "flex",
            position: "fixed",
            zIndex: 999,
            whiteSpace: "pre-line",
          };
          setModal(
            <div
              className="popUpNewUser justify-content-center align-items-center"
              style={styleModal}
            >
              <div
                className="modalInfoContenido"
                style={{
                  background: "white",
                  borderRadius: "20px",
                  boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                  padding: "2% 6%",
                }}
              >
                <div
                  className=""
                  style={{
                    position: "absolute",
                    top: "5%",
                    right: "1%",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    color: " #9DACBD",
                    cursor: "pointer",
                  }}
                  onClick={() => setModal(null)}
                >
                  <i className="bi bi-x-circle"></i>
                </div>
                <div
                  className=" mb-3 py-3"
                  style={{
                    lineHeight: "120%",
                    textAlign: "center",

                    minWidth: "calc(18rem + 1vmin)",

                    color: "var(--elevvabutonLogin_User)",
                  }}
                >
                  <br />
                  Se ha creado
                  <br />
                  <strong>correctamente.</strong>
                  <br />
                </div>
                <form id="form-teepassword-change" onSubmit={hideModal}>
                  <div className="col-12">
                    <div className="col-12 btnAction_pruebas letraspopfi2">
                      <ButtonMob
                        colorButton={"var(--elevvabutonLogin_User)"}
                        text="Confirmar"
                        className={"mb-3 mt-3 letraspopfi2actualizar"}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          );
        }
      })
      .catch((err) => {
        let msg_error = err.response.data;
        if (msg_error) {
          seterroraGregado(msg_error);

          setDisplayCorrect("flex");
          setTimeout(() => {
            setDisplayCorrect("none");
          }, 5000);
        }
      });

    event.preventDefault();
  }
  function createNewUser(event) {
    if (!event.target) return;
    let value = event.target[0].value;
    let membership = event.target[1].value;
    let plan = event.target[3]?.value || 0;
    let dateStart =
      event.target[5]?.value && event.target[5]?.value !== "Fecha de inicio"
        ? moment(event.target[5].value).format("DD-MM-YYYY")
        : null;
    let payment = event.target["payment_method"]?.value?.trim();

    var formData = new FormData();
    formData.append("email", value.trim());
    formData.append("plan_id", plan === "Fecha de inicio" ? 0 : plan);
    formData.append("membership", membership);
    formData.append(
      "payment",
      payment && payment !== "" ? parseInt(payment, 10) : 0
    );
    if (dateStart) {
      formData.append("date", dateStart);
    }
    setLoaderNewUser(true);
    instance
      .post(`memberships/corp/company/members/preregister`, formData)
      .then((res) => {
        if (res.data) {
          // setLoaderNewUser(false);
          setModalNewUser(null);
          setModalConfirm(null);
          let styleModal = {
            display: "flex",
            position: "fixed",
            zIndex: 999,
            whiteSpace: "pre-line",
          };
          setModal(
            <div
              className="popUpNewUser justify-content-center align-items-center"
              style={styleModal}
            >
              <div
                className="modalInfoContenido"
                style={{
                  background: "white",
                  borderRadius: "20px",
                  boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                  padding: "2% 6%",
                }}
              >
                <div
                  className=""
                  style={{
                    position: "absolute",
                    top: "5%",
                    right: "1%",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    color: " #9DACBD",
                    cursor: "pointer",
                  }}
                  onClick={() => setModal(null)}
                >
                  <i className="bi bi-x-circle"></i>
                </div>
                <div
                  className=" mb-3 py-3"
                  style={{
                    lineHeight: "120%",
                    textAlign: "center",

                    minWidth: "calc(18rem + 1vmin)",

                    color: "var(--elevvabutonLogin_User)",
                  }}
                >
                  <br />
                  El usuario ha
                  <br />
                  <strong> sido agregado</strong>
                  <br />
                  <strong>correctamente.</strong>
                  <br />
                </div>
                <form id="form-password-change" onSubmit={hideModal}>
                  <div className="col-12">
                    <div className="col-12 btnAction_pruebas letraspopfi2">
                      <ButtonMob
                        colorButton={"var(--elevvabutonLogin_User)"}
                        text="Confirmar"
                        className={"mb-3 mt-3 letraspopfi2actualizar"}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          );
        }
      })
      .catch((err) => {
        let msg_error = err.response.data;
        if (msg_error) {
          seterroraGregadoCreateUser(msg_error);

          setDisplayCorrect("flex");
          setTimeout(() => {
            seterroraGregadoCreateUser("");
            setDisplayCorrect("none");
          }, 5000);
        }
      })
      .finally(() => {
        setLoaderNewUser(false);
      });

    event.preventDefault();
  }
  function addTagUser() {
    if (userSelected.length > 0) {
      let styleModal = {
        display: "flex",
        position: "fixed",
        zIndex: 999,
        whiteSpace: "pre-line",
      };
      setModalError(
        <div
          className="popUpNewUser justify-content-center align-items-center"
          style={styleModal}
        >
          <div
            className="modalInfoContenido"
            style={{
              background: "white",
              borderRadius: "20px",
              boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
              padding: "10%",
            }}
          >
            <div
              className=""
              style={{
                position: "absolute",
                top: "5%",
                right: "1%",
                fontWeight: "bold",
                fontSize: "1.5rem",
                color: " #9DACBD",
                cursor: "pointer",
              }}
              onClick={() => setModalError(null)}
            >
              <i className="bi bi-x-circle"></i>
            </div>
            <div
              className=" mb-3 py-3"
              style={{
                lineHeight: "100%",
                textAlign: "center",

                color: "var(--elevvabutonLogin_User)",
              }}
            >
              <div
                className=" pt-3 my-4"
                style={{
                  lineHeight: "100%",
                  textAlign: "center",

                  color: "var(--elevvabutonLogin_User)",
                }}
              >
                Debes seleccionar <br></br>
                <strong> un usuario</strong>
              </div>
              <ButtonMob
                handleClick={() => setModalError(null)}
                colorButton={"var(--elevvabutonLogin_User)"}
                text={"Continuar"}
                className={"mb-3 mt-3 letraspopfi2actualizar"}
              />
            </div>
          </div>
        </div>
      );
    } else {
      var formData = new FormData();
      formData.append("members_to_remove", userSelected.user_id);

      instance
        .post(
          `memberships/corp/${userSelected.membership_id}/members/remove`,
          formData
        )
        .then((res) => {
          if (res.data) {
            let styleModal = {
              display: "flex",
              position: "fixed",
              zIndex: 999,
              whiteSpace: "pre-line",
            };
            getUsersFilter("");

            setModal(
              <div
                className="popUpNewUser justify-content-center align-items-center"
                style={styleModal}
              >
                <div
                  className="modalInfoContenido"
                  style={{
                    background: "white",
                    borderRadius: "20px",
                    boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                    padding: "2% 6%",
                  }}
                >
                  <div
                    className=""
                    style={{
                      position: "absolute",
                      top: "5%",
                      right: "1%",
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                      color: " #9DACBD",
                      cursor: "pointer",
                    }}
                    onClick={() => setModal(null)}
                  >
                    <i className="bi bi-x-circle"></i>
                  </div>
                  <div
                    className=" mb-3 py-3"
                    style={{
                      lineHeight: "120%",
                      textAlign: "center",

                      minWidth: "calc(18rem + 1vmin)",

                      color: "var(--elevvabutonLogin_User)",
                    }}
                  >
                    <br />
                    El usuario ha
                    <br />
                    <strong> sido eliminado</strong>
                    <br />
                    <strong>correctamente.</strong>
                    <br />
                  </div>

                  <div className="col-12">
                    <div className="col-12 btnAction_pruebas letraspopfi2">
                      <ButtonMob
                        handleClick={() => {
                          setModal(null);
                        }}
                        colorButton={"var(--elevvabutonLogin_User)"}
                        text="Confirmar"
                        className={"mb-3 mt-3 letraspopfi2actualizar"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })
        .catch((err) => {
          let msg_error = err.response.data;
          if (msg_error) {
            seterroraGregado(msg_error);

            setDisplayCorrect("flex");
            setTimeout(() => {
              setDisplayCorrect("none");
            }, 5000);
          }
        });
    }
  }
  function deleteTag(tag) {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    const formData = new FormData();
    formData.append("name", tag.name);
    setModal(
      <div
        className="popUpNewUser justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 6%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "120%",
              textAlign: "center",

              minWidth: "calc(18rem + 1vmin)",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            <br />
            Esta seguro de eliminar a
            <br />
            <strong> {tag.name} ??</strong>
            <br />
            <br />
          </div>

          <div className="col-12">
            <div className="col-12 btnAction_pruebas letraspopfi2">
              <ButtonMob
                handleClick={() => {
                  instance
                    .delete(`memberships/corp/tags/${tag.id}`, formData)
                    .then((res) => {
                      setModal(null);
                      getTags();
                    })
                    .catch((err) => {
                      let msg_error = err.response.data;
                      if (msg_error) {
                        console.log(err);
                      }
                    });
                }}
                colorButton={"var(--elevvabutonLogin_User)"}
                text="Confirmar"
                className={"mb-3 mt-3 letraspopfi2actualizar"}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  function editTag(event, tag) {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    let value = event.target[0].value;
    const formData = new FormData();
    formData.append("name", value);

    instance
      .patch(`memberships/corp/tags/${tag.id}`, formData)
      .then((res) => {
        getTags();
        setModal(
          <div
            className="popUpNewUser justify-content-center align-items-center"
            style={styleModal}
          >
            <div
              className="modalInfoContenido"
              style={{
                background: "white",
                borderRadius: "20px",
                boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                padding: "2% 6%",
              }}
            >
              <div
                className=""
                style={{
                  position: "absolute",
                  top: "5%",
                  right: "1%",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  color: " #9DACBD",
                  cursor: "pointer",
                }}
                onClick={() => setModal(null)}
              >
                <i className="bi bi-x-circle"></i>
              </div>
              <div
                className=" mb-3 py-3"
                style={{
                  lineHeight: "120%",
                  textAlign: "center",

                  minWidth: "calc(18rem + 1vmin)",

                  color: "var(--elevvabutonLogin_User)",
                }}
              >
                <br />
                Editada
                <br />
                <strong>correctamente</strong>
                <br />
                <br />
              </div>

              <div className="col-12">
                <div className="col-12 btnAction_pruebas letraspopfi2">
                  <ButtonMob
                    handleClick={() => {
                      setModal(null);
                    }}
                    colorButton={"var(--elevvabutonLogin_User)"}
                    text="Confirmar"
                    className={"mb-3 mt-3 letraspopfi2actualizar"}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })
      .catch((err) => {
        let msg_error = err.response.data;
        if (msg_error) {
          console.log(err);
        }
      });
  }
  function editMembership(event, user_id) {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };

    event.preventDefault();

    const formData = new FormData(event.target);
    const selectedMembership = formData.get("membership-admin");

    formData.append("user_id", user_id);
    formData.append("membership_id", selectedMembership);
    instance
      .post(`memberships/corp/members/change`, formData)
      .then((res) => {
        getUsers();
        setModal(
          <div
            className="popUpNewUser justify-content-center align-items-center"
            style={styleModal}
          >
            <div
              className="modalInfoContenido"
              style={{
                background: "white",
                borderRadius: "20px",
                boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                padding: "2% 6%",
              }}
            >
              <div
                className=""
                style={{
                  position: "absolute",
                  top: "5%",
                  right: "1%",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  color: " #9DACBD",
                  cursor: "pointer",
                }}
                onClick={() => setModal(null)}
              >
                <i className="bi bi-x-circle"></i>
              </div>
              <div
                className=" mb-3 py-3"
                style={{
                  lineHeight: "120%",
                  textAlign: "center",

                  minWidth: "calc(18rem + 1vmin)",

                  color: "var(--elevvabutonLogin_User)",
                }}
              >
                <br />
                Editado
                <br />
                <strong>correctamente</strong>
                <br />
                <br />
              </div>

              <div className="col-12">
                <div className="col-12 btnAction_pruebas letraspopfi2">
                  <ButtonMob
                    handleClick={() => {
                      setModal(null);
                    }}
                    colorButton={"var(--elevvabutonLogin_User)"}
                    text="Confirmar"
                    className={"mb-3 mt-3 letraspopfi2actualizar"}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })
      .catch((err) => {
        let msg_error = err.response.data;
        if (msg_error) {
          console.log(err);
        }
      });
  }
  function deleteUser() {
    var formData = new FormData();
    let vectorUsers = userSelected;

    let sender_string =
      vectorUsers.length === 1 ? vectorUsers[0] : vectorUsers.join(",");
    formData.append("members_to_remove", sender_string);
    instance
      .post(`memberships/corp/members/remove`, formData)
      .then((res) => {
        if (res.data) {
          let styleModal = {
            display: "flex",
            position: "fixed",
            zIndex: 999,
            whiteSpace: "pre-line",
          };
          getUsersFilter("");

          setModal(
            <div
              className="popUpNewUser justify-content-center align-items-center"
              style={styleModal}
            >
              <div
                className="modalInfoContenido"
                style={{
                  background: "white",
                  borderRadius: "20px",
                  boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                  padding: "2% 6%",
                }}
              >
                <div
                  className=""
                  style={{
                    position: "absolute",
                    top: "5%",
                    right: "1%",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    color: " #9DACBD",
                    cursor: "pointer",
                  }}
                  onClick={() => setModal(null)}
                >
                  <i className="bi bi-x-circle"></i>
                </div>
                <div
                  className=" mb-3 py-3"
                  style={{
                    lineHeight: "120%",
                    textAlign: "center",

                    minWidth: "calc(18rem + 1vmin)",

                    color: "var(--elevvabutonLogin_User)",
                  }}
                >
                  <br />
                  usuario(s)
                  <br />
                  <strong> eliminado(s)</strong>
                  <br />
                  <strong>correctamente.</strong>
                  <br />
                </div>

                <div className="col-12">
                  <div className="col-12 btnAction_pruebas letraspopfi2">
                    <ButtonMob
                      handleClick={() => {
                        setModal(null);
                        setUserSelected([]);
                      }}
                      colorButton={"var(--elevvabutonLogin_User)"}
                      text="Confirmar"
                      className={"mb-3 mt-3 letraspopfi2actualizar"}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        }
      })
      .catch((err) => {
        let msg_error = err.response.data;
        if (msg_error) {
          seterroraGregado(msg_error);

          setDisplayCorrect("flex");
          setTimeout(() => {
            setDisplayCorrect("none");
          }, 5000);
        }
      });
  }
  const hideModal = () => {
    setModal(null);
  };
  async function handleDownloadExcel() {
    instance.get(`memberships/corp/company/members/excel`);

    try {
      const response = await instance.get(
        "memberships/corp/company/members/excel",
        {
          responseType: "blob", // Importante para manejar archivos binarios
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      // Crear un enlace de descarga y asignar la URL del Blob
      const link = document.createElement("a");
      link.href = url;

      // Asignar un nombre al archivo Excel para la descarga
      link.setAttribute("download", "archivo_descargado.xlsx"); // Cambia el nombre según corresponda

      // Añadir el enlace al DOM y simular el clic
      document.body.appendChild(link);
      link.click();

      // Limpiar después de la descarga
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar el archivo Excel:", error);
    }
  }
  function handleDeleteUser() {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModal(
      <div
        className="popUpNewUser justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "6% 10%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          {userSelected.length > 0 ? (
            <div
              className=" pt-3 my-4 mx-auto"
              style={{
                lineHeight: "100%",
                textAlign: "center",
                maxWidth: "30rem",

                color: "var(--elevvabutonLogin_User)",
              }}
            >
              ¿Estás seguro de <br></br>
              <strong>
                eliminar a{" "}
                {userSelected.length >= 10
                  ? " a todos los usuarios en esta búsqueda"
                  : userSelected
                    .map((userId) => {
                      // Encuentra el usuario correspondiente
                      const user = users.find((u) => u.user_id === userId);
                      // Devuelve el full_name si el usuario fue encontrado
                      return user ? user.full_name : null;
                    })
                    // Filtra los valores nulos por si algún usuario no fue encontrado
                    .filter((fullName) => fullName !== null)
                    .join(", ")}
                ?{" "}
              </strong>
            </div>
          ) : (
            <div
              className=" pt-3 my-4"
              style={{
                lineHeight: "100%",
                textAlign: "center",

                color: "var(--elevvabutonLogin_User)",
              }}
            >
              Debes seleccionar <br></br>
              <strong> un usuario</strong>
            </div>
          )}
          <ButtonMob
            handleClick={
              userSelected.length > 0
                ? () => deleteUser()
                : () => setModal(null)
            }
            colorButton={"var(--elevvabutonLogin_User)"}
            text={userSelected ? "Confirmar" : "Continuar"}
            className={"mb-3 mt-3 letraspopfi2actualizar"}
          />
        </div>
      </div>
    );
  }
  function editMembershipClient(user_id) {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };

    setModal(
      <div
        className="popUpNewUser justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 6%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            Editar <strong>membresía</strong>
          </div>
          <form
            id="form-membership-edit"
            onSubmit={(e) => {
              editMembership(e, user_id);
            }}
          >
            <PerfectScrollbar style={{ maxHeight: "7rem", padding: "0 1rem" }}>
              {totalMemberships.map((mem) => (
                <div
                  key={mem.id}
                  className="py-2 d-flex align-items-center gap-2"
                  style={{
                    borderBottom: "1px solid #9DACBD",
                    justifyContent: "space-between",
                    minWidth: "15rem",
                  }}
                >
                  <div>
                    <input
                      type="radio"
                      name="membership-admin"
                      value={mem.id}
                    ></input>{" "}
                    <span>{mem.name}</span>
                  </div>
                </div>
              ))}
            </PerfectScrollbar>
            <div className="col-12">
              <div className="col-12 btnAction_pruebas letraspopfi2">
                <ButtonMob
                  colorButton={"var(--elevvabutonLogin_User)"}
                  text="Confirmar"
                  className={"mb-3 mt-3 letraspopfi2actualizar"}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
  function handleNewUser() {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModalNewUser(
      <div
        className="popUpServices justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 6%",
            maxWidth: "25rem",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "5%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModalNewUser(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            Nuevo <strong>Usuario</strong>
          </div>
          <form
            id="form-password-change"
            onSubmit={(e) => {
              createNewUser(e);
            }}
            className="py-4 px-4"
          >
            <input
              className="form-control input-style-elevva py-2"
              style={{
                minWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.4rem + .4vw)",
              }}
              name="tester"
              placeholder="Ingresa el correo electrónico"
              required
            />
            <div className="d-flex  my-2 w-100 " id="location-select">
              <DropdownList
                style={{ width: "100%" }}
                busy
                name="membership"
                busySpinner={<ArrowDown></ArrowDown>}
                className={"input-style-elevva-graphics"}
                id="optionSummary"
                placeholder={"Membresías"}
                data={
                  totalMemberships &&
                  totalMemberships.map((memb) => ({
                    id: memb.id,
                    name: memb.name,
                  }))
                }
                dataKey="id"
                textField="name"
                onChange={() => { }}
                renderListItem={({ item }) => (
                  <div
                    className="w-100 mb-1"
                    style={{ borderBottom: "1px solid #9DACBD" }}
                  >
                    <div>{item.name}</div>
                  </div>
                )}
              />
            </div>
            <div className="col-11 mx-auto" style={{ lineHeight: "1" }}>
              <span
                style={{
                  fontSize: "calc(.4rem + .4vw)",
                  color: "#9DACBD",
                }}
              >
                Aquí administrarás y asignarás el plan de accesos e iniciación
                de tu usuario
              </span>
            </div>
            {localStorage.mob_integration &&
              JSON.parse(localStorage.mob_integration) &&
              planesMob && (
                <div className="d-flex  my-2 w-100 " id="location-select">
                  <DropdownList
                    style={{ width: "100%" }}
                    busy
                    busySpinner={<ArrowDown></ArrowDown>}
                    className={"input-style-elevva-graphics"}
                    id="optionSummary"
                    placeholder={"Planes"}
                    name="plan_id"
                    data={
                      planesMob &&
                      planesMob.map((memb) => ({
                        id: memb.id,
                        name: memb.name,
                      }))
                    }
                    dataKey="id"
                    textField="name"
                    onChange={() => { }}
                    renderListItem={({ item }) => (
                      <div
                        className="w-100 mb-1"
                        style={{ borderBottom: "1px solid #9DACBD" }}
                      >
                        <div>{item.name}</div>
                      </div>
                    )}
                  />
                </div>
              )}

            <DateInputStart />
            <br />
            <div className="d-flex  my-2 w-100 " id="payment-method-select">
              <DropdownList
                style={{ width: "100%" }}
                busy
                name="payment_method"
                busySpinner={<ArrowDown></ArrowDown>}
                className={"input-style-elevva-graphics"}
                id="optionSummary"
                placeholder={"Método de Pago"}
                data={[
                  { id: 10, name: "Tarjeta de Crédito o Débito" },
                  { id: 20, name: "Transferencia" },
                  { id: 30, name: "Efectivo" },
                ]}
                dataKey="id"
                textField="name"
                onChange={() => { }}
                renderListItem={({ item }) => (
                  <div
                    className="w-100 mb-1"
                    style={{ borderBottom: "1px solid #9DACBD" }}
                  >
                    <div>{item.name}</div>
                  </div>
                )}
              />
            </div>
            <div
              id="new_user_error"
              className=""
              style={{
                display: `${displayCorrect}`,
                color: "var(--elevva)",
                maxWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.3rem + .3vw)",
              }}
            >
              {ErroraGregadoCreateUser ? ErroraGregadoCreateUser : null}
            </div>
            <div className="col-12">
              <div className="col-12 btnAction_pruebas letraspopfi2">
                <ButtonMob
                  disabled={loaderNewUser}
                  colorButton={"var(--elevvabutonLogin_User)"}
                  text={loaderNewUser ? "Cargando..." : "Confirmar"}
                  className={"mb-3 mt-3 letraspopfi2actualizar"}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
  function editModalTag(tag) {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModal(
      <div
        className="popUpNewUser justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 6%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            Editar <strong>etiqueta</strong>
          </div>
          <form
            id="form-password-change"
            onSubmit={(e) => {
              e.preventDefault();
              editTag(e, tag);
            }}
          >
            {" "}
            <input
              className="form-control input-style-elevva "
              style={{
                minWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.4rem + .4vw)",
              }}
              name="tag_name_edit"
              placeholder="Introduce el nombre de la etiqueta"
              required
            />
            <br />
            <div
              id="new_user_er"
              className=""
              style={{
                display: `${displayCorrect}`,
                color: "var(--elevva)",
                maxWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.3rem + .3vw)",
              }}
            >
              {ErroraGregado ? ErroraGregado.password : null}
            </div>
            <div className="col-12">
              <div className="col-12 btnAction_pruebas letraspopfi2">
                <ButtonMob
                  colorButton={"var(--elevvabutonLogin_User)"}
                  text="Confirmar"
                  className={"mb-3 mt-3 letraspopfi2actualizar"}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
  function assignTag() {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModal(
      <div
        className="popUpNewUser justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 6%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          ></div>
          <form
            id="assign-tag-form"
            onSubmit={(e) => {
              assingNewTag(e);
            }}
          >
            {" "}
            <br />
            <div
              className=" mb-3 py-3"
              style={{
                lineHeight: "120%",
                textAlign: "center",

                minWidth: "calc(18rem + 1vmin)",

                color: "var(--elevvabutonLogin_User)",
              }}
            >
              <br />
              Estás seguro
              <br />
              <strong>de agregar etiquetas.</strong>
              <br />
            </div>
            <div
              id="new_user_error"
              className=""
              style={{
                display: `${displayCorrect}`,
                color: "var(--elevva)",
                maxWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.3rem + .3vw)",
              }}
            >
              {ErroraGregado ? ErroraGregado.password : null}
            </div>
            <div className="col-12">
              <div className="col-12 btnAction_pruebas letraspopfi2">
                <ButtonMob
                  colorButton={"var(--elevvabutonLogin_User)"}
                  text="Confirmar"
                  className={"mb-3 mt-3 letraspopfi2actualizar"}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
  function createTag() {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModal(
      <div
        className="popUpNewUser justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "2% 6%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            Nueva <strong>etiqueta</strong>
          </div>
          <form
            id="form-password-change"
            onSubmit={(e) => {
              createNewTag(e);
            }}
          >
            {" "}
            <input
              className="form-control input-style-elevva "
              style={{
                minWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.4rem + .4vw)",
              }}
              name="tag_name"
              placeholder="Introduce el nombre de la nueva etiqueta"
              required
            />
            <br />
            <div
              id="new_user_error"
              className=""
              style={{
                display: `${displayCorrect}`,
                color: "var(--elevva)",
                maxWidth: "calc(18rem + 1vmin)",
                fontSize: "calc(.3rem + .3vw)",
              }}
            >
              {ErroraGregado ? ErroraGregado.password : null}
            </div>
            <div className="col-12">
              <div className="col-12 btnAction_pruebas letraspopfi2">
                <ButtonMob
                  colorButton={"var(--elevvabutonLogin_User)"}
                  text="Confirmar"
                  className={"mb-3 mt-3 letraspopfi2actualizar"}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
  function manageTags() {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModal(
      <div
        className="popUpNewUser justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "4% 10%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            Gestionar <strong>Etiquetas</strong>
          </div>
          <form
            id="form-tags"
            onSubmit={(e) => {
              e.preventDefault();
              addTagUser(e);
            }}
          >
            <PerfectScrollbar style={{ maxHeight: "7rem", padding: "0 1rem" }}>
              {tags.map((tag) => (
                <div
                  key={tag.id}
                  className="py-2 d-flex align-items-center gap-2"
                  style={{
                    borderBottom: "1px solid #9DACBD",
                    justifyContent: "space-between",
                    minWidth: "15rem",
                  }}
                >
                  <div>
                    <span>{tag.name}</span>
                  </div>
                  <div className="d-flex gap-2">
                    <div
                      className="cursor-pointer"
                      onClick={() => editModalTag(tag)}
                    >
                      <EditTag width={"100%"} />
                    </div>

                    <div
                      className="cursor-pointer"
                      onClick={() => deleteTag(tag)}
                      width={"2rem"}
                    >
                      {" "}
                      <DeleteTag width={"100%"} />
                    </div>
                  </div>
                </div>
              ))}
            </PerfectScrollbar>
            <span> {ErroraGregado}</span>
          </form>
        </div>
      </div>
    );
  }
  function handlerTags() {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };
    setModal(
      <div
        className="popUpNewUser justify-content-center align-items-center"
        style={styleModal}
      >
        <div
          className="modalInfoContenido"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
            padding: "4% 10%",
          }}
        >
          <div
            className=""
            style={{
              position: "absolute",
              top: "5%",
              right: "1%",
              fontWeight: "bold",
              fontSize: "1.5rem",
              color: " #9DACBD",
              cursor: "pointer",
            }}
            onClick={() => setModal(null)}
          >
            <i className="bi bi-x-circle"></i>
          </div>
          <div
            className=" mb-3 py-3"
            style={{
              lineHeight: "100%",
              textAlign: "center",

              color: "var(--elevvabutonLogin_User)",
            }}
          >
            <strong>Etiquetar como:</strong>
          </div>
          <div>
            <div style={{ position: "relative", marginLeft: "auto" }}>
              {" "}
              <input
                type="search"
                className="searchUsers "
                style={{
                  borderBottom: "1px solid var(--elevvaTextSubtitle)",
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",

                  padding: "0.4rem 1rem",
                }}
                onChange={(e) => {
                  updateFilterTag(e);
                }}
              ></input>
              <span className="search-icon-admin pe-5">
                <SearchIconAlone fontSize={10} />
              </span>
            </div>
          </div>
          <form
            id="form-tags"
            onSubmit={(e) => {
              e.preventDefault();
              addTagUser(e);
            }}
          >
            {tags.length > 0 ? (
              <PerfectScrollbar style={{ maxHeight: "7rem" }}>
                {tags.map((tag) => (
                  <div
                    key={tag.id}
                    className="py-2 d-flex align-items-center gap-2"
                    style={{
                      borderBottom: "1px solid #9DACBD",
                      minWidth: "15rem",
                    }}
                  >
                    <div>
                      <input
                        type="checkbox"
                        onChange={() => {
                          setTagsSelected((prev) => {
                            if (prev.includes(tag.id)) {
                              return prev.filter((item) => item !== tag.id);
                            }
                            return [...prev, tag.id];
                          });
                        }}
                      ></input>
                    </div>
                    <div>
                      <span>{tag.name}</span>
                    </div>
                  </div>
                ))}
              </PerfectScrollbar>
            ) : (
              "No existen etiquetas"
            )}
            <span> {ErroraGregado}</span>
          </form>
          <ButtonMob
            handleClick={createTag}
            colorButton={"var(--elevvabutonLogin_User)"}
            text="Crear etiqueta"
            className={"mb-3 mt-3 letraspopfi2actualizar"}
          />
          {userSelected.length > 0 && tagsSelected.length > 0 && (
            <ButtonMob
              handleClick={assignTag}
              colorButton={"var(--elevvabutonLogin_User)"}
              text="Asignar etiqueta"
              className={"mb-3 mt-3 letraspopfi2actualizar"}
            />
          )}
          <ButtonMob
            handleClick={manageTags}
            colorButton={"var(--elevvabutonLogin_User)"}
            text="Gestionar etiquetas"
            className={"mb-3 mt-3 letraspopfi2actualizar"}
          />
        </div>
      </div>
    );
  }
  function getDetailCompany() {
    instance
      .get("memberships/corp/company")
      .then((res) => res.data)
      .then((data) => {
        setDetailCompany(data);
      })
      .catch((err) => console.error(err));
  }
  function searchUsers(e) {
    let valueLower = e.target.value.toLowerCase();
    if (valueLower == "") {
      setUsers(dataBackup.results.filter((memb) => memb.active === true));
      setCount(dataBackup.count);
      setPageNext(dataBackup.next);
      setPageBack(dataBackup.previous);
    } else {
      getUsersFilter(valueLower);
    }
  }
  function getMemberships() {
    instance
      .get("memberships/corp/memberships")
      .then((res) => res.data)
      .then((data) => {
        settotalMemberships(data);
      })
      .catch((err) => console.error(err));
  }
  useEffect(() => {
    getUsers();
    getTags();
    getDetailCompany();
    getMemberships();
  }, []);
  const convertToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  function changePage(value) {
    if (value == "next") {
      getUsersPage(pageNext);

      if (page * 10 - 10 >= count) {
        setPage(count);
      } else {
        setPage(page + 1);
      }
    }
    if (value == "previous") {
      getUsersPage(pageBack);
      if (page - 1 === 0) {
        setPage(1);
      } else {
        setPage(page - 1);
      }
    }
  }
  const generatePdf = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const marginX = 20;
    const marginY = 55;
    const lineHeight = 6;

    // --- LOGO SUPERIOR ---
    const logoUrl = "/assets/logo_normal_128.png";
    const logoImage = await fetch(logoUrl).then((res) => res.blob());
    const logoBase64 = await convertToBase64(logoImage);

    doc.addImage(logoBase64, "PNG", pageWidth / 2 - 12, 15, 25, 10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor("#394F65");
    doc.setFontSize(16);
    doc.text(
      "CONTRATO ÚNICO DE EXCLUSIÓN DE RESPONSABILIDAD,",
      pageWidth / 2,
      35,
      { align: "center" }
    );
    doc.text(
      "CONSENTIMIENTO INFORMADO Y MANEJO DE DATOS",
      pageWidth / 2,
      42,
      { align: "center" }
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor("#394F65");

    // --- CUERPO DEL CONTRATO ---
    const contratoTexto = `
Entre: ${detailCompany?.name || "[Nombre del Gimnasio]"}, identificado con NIT ${detailCompany?.nit || "[xxxxxx]"
      }, en adelante el “GIMNASIO”, y ${userDetail?.full_name || "[Nombre del Usuario]"}, identificado con ${userDetail?.document || "[Documento]"
      }, en adelante el “USUARIO”, se celebra el presente Contrato de Exclusión de Responsabilidad, Consentimiento Informado y Manejo de Datos, bajo las siguientes cláusulas:

PRIMERA – OBJETO
El presente contrato regula las condiciones bajo las cuales EL PRESTADOR ofrecerá al USUARIO acceso, uso y participación en actividades físicas, deportivas, recreativas y servicios complementarios, conforme a:
a) Este contrato
b) El Reglamento General de Servicios
c) Reglamentos específicos de cada actividad
SEGUNDA – CONSENTIMIENTO INFORMADO Y ASUNCIÓN DE RIESGOS
El USUARIO declara que:
1.\tHa sido informado de que toda actividad física implica riesgos inherentes como: lesiones, desgarros, esguinces, fracturas, problemas cardiovasculares, caídas, mareos, pérdida de conciencia e incluso muerte súbita.
2.\tReconoce que estos riesgos existen incluso siguiendo las indicaciones de instructores.
3.\tAcepta voluntariamente dichos riesgos y participa bajo su propia responsabilidad.
4.\tExonera a EL PRESTADOR, sus propietarios, instructores, colaboradores y personal administrativo de cualquier lesión o perjuicio sufrido antes, durante o después de la actividad física, salvo en casos de dolo o culpa grave comprobada.
5.\tSe compromete a informar cualquier condición médica o antecedente relevante.
TERCERA – OBLIGACIONES DEL USUARIO
El USUARIO se compromete a:
1.\tCumplir el Reglamento General de Servicios.
2.\tSeguir las instrucciones de instructores y personal autorizado.
3.\tUsar adecuadamente instalaciones y equipos.
4.\tProporcionar información veraz sobre su salud.
5.\tRealizar valoración física inicial y seguimientos.
6.\tNo entrenar bajo efectos de alcohol, medicamentos sedantes o sustancias psicoactivas.
7.\tCuidar equipos e instalaciones.
8.\tAsumir daños causados por uso indebido.
9.\tPagar oportunamente el plan contratado.
CUARTA – OBLIGACIONES DEL PRESTADOR
EL PRESTADOR debe:
1.\tMantener instalaciones seguras, higiénicas y en funcionamiento.
2.\tProveer equipos aptos para la práctica deportiva.
3.\tBrindar acompañamiento profesional conforme al plan contratado.
4.\tHacer cumplir el Reglamento General de Servicios.
QUINTA – PÉRDIDA O DAÑO DE OBJETOS PERSONALES
EL PRESTADOR no es responsable por pérdida, daño o hurto de objetos personales dentro o fuera de las instalaciones, incluyendo casilleros, zonas comunes o áreas de entrenamiento.
SEXTA – POLÍTICAS COMERCIALES
1.\tLos planes son personales e intransferibles.
2.\tNo hay devoluciones de dinero, salvo obligación legal.
3.\tNo se realizan congelaciones, prórrogas ni cesiones, salvo:
o\tIncapacidad médica
o\tEmbarazo
o\tCasos excepcionales autorizados por EL PRESTADOR
4.\tServicios externos (nutrición, entrenadores particulares, fisioterapia independiente, etc.) son responsabilidad del USUARIO.
SÉPTIMA – CLÁUSULA DE INDEMNIDAD
El USUARIO mantendrá indemne al PRESTADOR frente a daños ocasionados a terceros o a las instalaciones por su conducta o negligencia.



OCTAVA – DERECHOS DE IMAGEN
El USUARIO autoriza al PRESTADOR a registrar fotografías o videos dentro del CENTRO DEPORTIVO y utilizarlos para fines informativos o promocionales sin compensación económica.
NOVENA – AUTORIZACIÓN PARA TRATAMIENTO DE DATOS PERSONALES
El USUARIO autoriza al PRESTADOR y a sus plataformas tecnológicas asociadas a recolectar y procesar datos personales y sensibles como: información de salud, composición corporal, progreso físico y datos de entrenamiento.
Los datos se usarán para:
a) Personalizar entrenamientos
b) Realizar seguimiento físico
c) Gestionar comunicaciones
d) Cumplir obligaciones legales
El tratamiento se hará conforme a la Ley 1581 de 2012. El USUARIO podrá solicitar actualización, corrección o supresión de datos.
DÉCIMA. – ACEPTACIÓN DE TÉRMINOS Y CONDICIONES DE LA PLATAFORMA ELEVVA
El USUARIO declara que ha leído y acepta los Términos y Condiciones de uso y la Política de Privacidad de la plataforma ELEVVA, disponibles en:
•\thttps://elevva.com.co/terminos-y-condiciones/
•\thttps://elevva.com.co/politica-privacidad/
El USUARIO entiende y acepta que:
1.\tEs responsable de la veracidad y actualización de sus datos.
2.\tELEVVA podrá actualizar sus políticas y condiciones, debiendo el USUARIO revisarlas periódicamente.
3.\tLa aceptación digital (mediante botón “Siguiente”, firma electrónica o similar) constituye plena validez jurídica del presente contrato.
DÉCIMA  PRIMERA – TERMINACIÓN
EL PRESTADOR podrá terminar unilateralmente el contrato, sin devolución de dinero, cuando el USUARIO:
•\tIncumpla el reglamento
•\tAgreda a otros usuarios o personal
•\tAfecte la convivencia
•\tCause daños deliberados
•\tPonga en riesgo la seguridad propia o de terceros
DÉCIMA SEGUNDA – DOMICILIO CONTRACTUAL
El contrato se rige por las leyes de la República de Colombia. El lugar de cumplimiento será la ciudad donde opere el CENTRO DEPORTIVO.
DÉCIMA TERCERA – ACUERDO TOTAL
Este contrato reemplaza cualquier acuerdo previo, verbal o escrito, entre las partes.

ANEXO: REGLAMENTO GENERAL DE SERVICIOS (DEL CENTRO DEPORTIVO)
1. Admisión
•\tEl ingreso requiere registro y pago al día.
•\tPlanes no transferibles ni reembolsables.
•\tMenores admitidos únicamente con autorización del representante legal.
•\tProhibido ingresar con armas o escoltas.
2. Presentación Personal
•\tUsar calzado adecuado.
•\tGuardar pertenencias en casilleros.
•\tProhibida la promoción o venta de productos sin autorización.
•\tProhibido fumar, vapear o consumir sustancias psicoactivas o alcohol.
3. Casilleros
•\tUso diario sin costo adicional.
•\tEl PRESTADOR puede retirar candados dejados al final del día.
•\tNo guardar objetos de valor.
4. Uso de Equipos
•\tSeguir indicaciones del personal.
•\tRegresar implementos a su lugar.
•\tNo ingresar equipos propios.
•\tReportar fallas de inmediato.
•\tEl PRESTADOR no responde por lesiones generadas por uso incorrecto.
5. Horarios
•\tEL PRESTADOR puede modificarlos sin previo aviso.
•\tEl cierre inicia 30 minutos antes del horario oficial.
6. Prohibiciones
•\tNo diseñar rutinas para otros usuarios.
•\tNo realizar ventas sin autorización.
•\tNo ingresar alimentos o bebidas alcohólicas.
7. Expulsión
El USUARIO puede ser expulsado por:
•\tViolencia
•\tIntentos de hurto
•\tDaños a instalaciones
•\tConsumo de sustancias
•\tComportamientos que alteren la convivencia
DÉCIMA CUARTA. – VIGENCIA
El presente contrato entra en vigencia desde su firma (o aceptación digital) y permanecerá activo durante todo el tiempo que el USUARIO utilice los servicios o instalaciones del GIMNASIO, sin perjuicio de su renovación o terminación conforme a las políticas internas.
DÉCIMA QUINTA. – DECLARACIÓN FINAL
El USUARIO declara haber leído, entendido y aceptado en su totalidad el presente contrato, firmando libre y voluntariamente, sin error, dolo ni coacción alguna.

`;

    // --- Dividir texto y crear saltos de página ---
    const lines = doc.splitTextToSize(contratoTexto, pageWidth - marginX * 2);
    let cursorY = marginY;

    lines.forEach((line) => {
      if (cursorY > pageHeight - 30) {
        doc.addPage();
        cursorY = 20;
      }
      doc.text(line, marginX, cursorY);
      cursorY += lineHeight;
    });

    if (cursorY > pageHeight - 65) {
      doc.addPage();
    }

    // --- Pie decorativo en última página ---
    doc.setFillColor(105, 130, 255);
    doc.moveTo(0, pageHeight - 37);
    doc.curveTo(50, pageHeight - 7, 160, pageHeight - 7, 210, pageHeight - 37);
    doc.lineTo(210, pageHeight);
    doc.lineTo(0, pageHeight);
    doc.fill();

    // --- Firma y botón ---
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor("#394F65");
    doc.text(`${userDetail?.full_name || ""}`, pageWidth / 2, pageHeight - 25, {
      align: "center",
    });
    // doc.addImage(


    const buttonWidth = 60;
    const buttonHeight = 10;
    const buttonX = (pageWidth - buttonWidth) / 2;
    const buttonY = pageHeight - 50;
    doc.setFillColor("#3E5060");
    doc.roundedRect(buttonX, buttonY, buttonWidth, buttonHeight, 5, 5, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor("#FFFFFF");
    doc.text("ACEPTO", pageWidth / 2, buttonY + buttonHeight / 1.6, {
      align: "center",
    });

    doc.setTextColor("#FFFFFF");
    doc.setFontSize(10);
    doc.text("www.app.elevva.com.co", pageWidth / 2, pageHeight - 7, {
      align: "center",
    });

    // --- Descargar PDF ---
    doc.save("Contrato_Exclusion.pdf");
  };
  const generatePdfTriage = async () => {
    // Referencia al div que queremos convertir en PDF
    const preguntas = [
      "¿Algún médico le ha dicho que tiene problemas del corazón y que sólo debe hacer actividades físicas recomendadas por un médico?",
      "¿Tiene dolor en el pecho cuando hace alguna actividad física?",
      "¿En el último mes, ¿ha tenido dolor en el pecho cuando no estaba haciendo actividades físicas?",
      "¿Pierde el equilibrio por mareos, o ha perdido alguna vez el conocimiento?",
      "¿Tiene problema en algún hueso o articulación que pueda ser agravado por un cambio en su actividad física?",
      "¿Está tomando medicamentos recetados por el médico para la presión arterial o para el corazón (por ejemplo, pastillas diuréticas)?",
      "¿Sabe de cualquier otra razón en contra de que ejercite?",
    ];
    let doc = new jsPDF("p", "mm", "a4");
    let yOffset = 140;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const logoUrl = "/assets/logo_normal_128.png"; // Ruta del logo en la carpeta pública
    const logoImage = await fetch(logoUrl).then((res) => res.blob());
    const logoBase64 = await convertToBase64(logoImage);

    doc.setFillColor(105, 130, 255);

    // Define the path for the curve
    doc.moveTo(0, 260); // Punto inicial
    doc.curveTo(50, 290, 160, 290, 210, 260); // Control points ajustados
    doc.lineTo(210, 297); // Extender hasta el borde inferior
    doc.lineTo(0, 297); // Completar el camino // Complete the path

    // Fill the curve
    doc.fill();

    // Agregar el logo al PDF
    doc.addImage(logoBase64, "PNG", pageWidth / 2 - 12, 15, 25, 10, {
      align: "center",
    });

    doc.setTextColor("#394F65");

    doc.text("TRIAGE / ", pageWidth / 2 - 30, 40, { align: "center" });
    doc.setFont("helvetica", "bold");
    doc.setTextColor("#7988F6");
    // Establecer fuente en negrita
    doc.text("ESTADO DEL ATLETA", pageWidth / 2 + 15, 40, { align: "center" });

    if (imageBase64User) {
      doc.addImage(imageBase64User, "jpg", pageWidth / 2 - 25, 50, 50, 50, {
        align: "center",
      });
    }

    doc.setFont("helvetica", "normal");
    doc.setTextColor("#394F65");
    doc.setFont("helvetica", "normal");

    doc.text(`${userDetail?.full_name}`, pageWidth / 2, 110, {
      align: "center",
    });
    doc.text(`cc ${userDetail?.document}`, pageWidth / 2, 115, {
      align: "center",
    });

    doc.setFontSize(13);
    preguntas.forEach((pregunta, index) => {
      doc.setTextColor("#394F65");
      doc.text(pregunta, 20, yOffset, { align: "left", maxWidth: "150" });
      if (index === 0) {
        if (userTriage?.health_safe_heart) {
          doc.setFillColor(50, 100, 150); // Color relleno
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "F");
          doc.setTextColor(255, 255, 255); // Color del texto
          doc.text("SI", 187.5, yOffset + 0.5, null, null, "center");
        } else {
          doc.setFillColor(255, 255, 255);
          doc.setDrawColor(50, 100, 150);
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "FD");
          doc.setTextColor(0, 0, 0);
          doc.text("NO", 187.5, yOffset + 0.5, null, null, "center");
        }
      } else if (index === 1) {
        if (userTriage?.health_safe_chest) {
          doc.setFillColor(50, 100, 150); // Color relleno
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "F");
          doc.setTextColor(255, 255, 255); // Color del texto
          doc.text("SI", 187.5, yOffset + 0.5, null, null, "center");
        } else {
          doc.setFillColor(255, 255, 255);
          doc.setDrawColor(50, 100, 150);
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "FD");
          doc.setTextColor(0, 0, 0);
          doc.text("NO", 187.5, yOffset + 0.5, null, null, "center");
        }
      } else if (index === 2) {
        if (userTriage?.health_safe_chest_last) {
          doc.setFillColor(50, 100, 150); // Color relleno
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "F");
          doc.setTextColor(255, 255, 255); // Color del texto
          doc.text("SI", 187.5, yOffset + 0.5, null, null, "center");
        } else {
          doc.setFillColor(255, 255, 255);
          doc.setDrawColor(50, 100, 150);
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "FD");
          doc.setTextColor(0, 0, 0);
          doc.text("NO", 187.5, yOffset + 0.5, null, null, "center");
        }
      } else if (index === 3) {
        if (userTriage?.health_safe_balance) {
          doc.setFillColor(50, 100, 150); // Color relleno
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "F");
          doc.setTextColor(255, 255, 255); // Color del texto
          doc.text("SI", 187.5, yOffset + 0.5, null, null, "center");
        } else {
          doc.setFillColor(255, 255, 255);
          doc.setDrawColor(50, 100, 150);
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "FD");
          doc.setTextColor(0, 0, 0);
          doc.text("NO", 187.5, yOffset + 0.5, null, null, "center");
        }
      } else if (index === 4) {
        if (userTriage?.health_safe_bones) {
          doc.setFillColor(50, 100, 150); // Color relleno
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "F");
          doc.setTextColor(255, 255, 255); // Color del texto
          doc.text("SI", 187.5, yOffset + 0.5, null, null, "center");
        } else {
          doc.setFillColor(255, 255, 255);
          doc.setDrawColor(50, 100, 150);
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "FD");
          doc.setTextColor(0, 0, 0);
          doc.text("NO", 187.5, yOffset + 0.5, null, null, "center");
        }
      } else if (index === 5) {
        if (userTriage?.health_safe_medicated) {
          doc.setFillColor(50, 100, 150); // Color relleno
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "F");
          doc.setTextColor(255, 255, 255); // Color del texto
          doc.text("SI", 187.5, yOffset + 0.5, null, null, "center");
        } else {
          doc.setFillColor(255, 255, 255);
          doc.setDrawColor(50, 100, 150);
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "FD");
          doc.setTextColor(0, 0, 0);
          doc.text("NO", 187.5, yOffset + 0.5, null, null, "center");
        }
      } else {
        if (userTriage?.health_safe_other) {
          doc.setFillColor(50, 100, 150); // Color relleno
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "F");
          doc.setTextColor(255, 255, 255); // Color del texto
          doc.text("SI", 167.5, yOffset, null, null, "center");
        } else {
          doc.setFillColor(255, 255, 255);
          doc.setDrawColor(50, 100, 150);
          doc.roundedRect(180, yOffset - 5, 15, 8, 3, 3, "FD");
          doc.setTextColor(0, 0, 0);
          doc.text("NO", 187.5, yOffset + 0.5, null, null, "center");
        }
      }
      yOffset += 15; // Espaciado entre preguntas
    });
    doc.setFontSize(15);
    doc.setTextColor("#FFFFFF");
    doc.setFont("helvetica", "normal");
    doc.text("www.app.elevva.com.co", pageWidth / 2, 290, { align: "center" });

    doc.html("string");

    // Descargar el PDF
    doc.save("documento.pdf");
  };
  const isBirthdayToday = (birthday) => {
    if (!birthday) return false; // Si no hay fecha, no es cumpleaños

    const birthdayFormatted = moment(birthday).format("DD-MMM");
    const todayFormatted = moment().format("DD-MMM");

    return birthdayFormatted === todayFormatted;
  };
  const getResponsiveMaxHeight = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    if (width <= 1280 && width >= 1024 && height <= 700) {
      return "calc(91vh - 17rem)";
    }
    return "calc(79vh - 17rem) ";
  };
  const handleDelete = async () => {
    if (!userToDelete) return;

    try {
      const formData = new FormData();
      formData.append("members_to_remove", userToDelete);

      await instance.post(
        "memberships/corp/members/remove", formData
      );

      getUsersFilter("");
    } catch (error) {
      console.error("Error eliminando usuario", error);
    } finally {
      setUserToDelete(null);
      setShowDeleteModal(false);
    }
  };

  return (
    <div className="h-100 p-3">
      {modal}

      {showModalPreRegister && (
        <PreRegisterUserModal show onHide={() => setShowModalPreRegister(false)} />
      )}

      {showDeleteModal && (
        <InlineModal
          show
          title="¿Deseas eliminar a este usuario?"
          primaryAction={{
            label: "Sí, eliminar",
            onClick: handleDelete,
            loading: false
          }}
          secondaryAction={{
            label: "Cancelar",
            onClick: () => {
              setShowDeleteModal(false);
              setUserToDelete(null);
            },
          }}
        />
      )}


      {modalNewUser}
      {modalError}
      {userDetail ? (
        stepUser === 1 ? (
          <div
            className="w-100 h-100 d-flex justify-content-center flex-column"
            style={{ padding: "2% 5%" }}
          >
            <div
              className="w-100 relative d-flex   align-items-center mb-3"
              style={{ justifyContent: "space-between" }}
            >
              <div>Perfil de usuario</div>{" "}
              <div
                className="mt-1"
                style={{
                  position: "relative",

                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  color: " #9DACBD",
                  cursor: "pointer",
                }}
                onClick={() => setUserDetail(null)}
              >
                <i className="bi bi-x-circle"></i>
              </div>
            </div>
            <div className=" w-100 d-flex justify-content-center ">
              <UserDetailComponent
                id={userDetail.user_id}
                handleStepUser={(e) => setStepUser(e)}
              />
            </div>
          </div>
        ) : stepUser === 2 ? (
          <div className="d-flex   align-items-center flex-column p-3">
            <div
              style={{ justifyContent: "flex-start", marginRight: "auto" }}
              className="d-flex   align-items-center "
            >
              <div>
                <ButtonArrow
                  classes=" btnBackPr me-1"
                  colorBack={`var(--elevvaArrowColor)`}
                  handleClick={() => setStepUser(1)}
                />
              </div>
              <span className="ms-1" style={{ color: "#395056" }}>
                Triage
              </span>
            </div>
            <PerfectScrollbar
              className="ps-5"
              style={{ maxHeight: "calc(100vh - 27rem)" }}
            >
              <div className="w-100 d-flex flex-column gap-3 px-4 mt-4">
                <div className="d-flex w-100 align-items-center gap-2">
                  <div style={{ width: "87%" }}>
                    {" "}
                    <span
                      style={{
                        color: "#394F65",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                    >
                      ¿Algún médico le ha dicho que tiene problemas del corazón
                      y que sólo debe hacer actividades físicas recomendadas por
                      un médico?
                    </span>
                  </div>
                  <div style={{ width: "13%" }}>
                    <button
                      style={{
                        width: "100%",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                      className={`d-flex ${userTriage?.health_safe_heart
                        ? "add_location "
                        : "add_location_negation "
                        }  py-1`}
                    >
                      {userTriage?.health_safe_heart ? "SI" : "NO"}
                    </button>
                  </div>
                </div>
                <div className="d-flex w-100 align-items-center gap-2">
                  <div style={{ width: "87%" }}>
                    {" "}
                    <span
                      style={{
                        color: "#394F65",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                    >
                      ¿Tiene dolor en el pecho cuando hace alguna actividad
                      física?
                    </span>
                  </div>
                  <div style={{ width: "13%" }}>
                    <button
                      style={{
                        width: "100%",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                      className={`d-flex ${userTriage?.health_safe_chest
                        ? "add_location "
                        : "add_location_negation "
                        }  py-1`}
                    >
                      {userTriage?.health_safe_chest ? "SI" : "NO"}
                    </button>
                  </div>
                </div>
                <div className="d-flex w-100 align-items-center gap-2">
                  <div style={{ width: "87%" }}>
                    {" "}
                    <span
                      style={{
                        color: "#394F65",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                    >
                      ¿En el último mes, ¿ha tenido dolor en el pecho cuando no
                      estaba haciendo actividades físicas?
                    </span>
                  </div>
                  <div style={{ width: "13%" }}>
                    <button
                      style={{
                        width: "100%",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                      className={`d-flex ${userTriage?.health_safe_chest_last
                        ? " add_location "
                        : " add_location_negation "
                        }  py-1`}
                    >
                      {userTriage?.health_safe_chest_last ? "SI" : "NO"}
                    </button>
                  </div>
                </div>
                <div className="d-flex w-100 align-items-center gap-2">
                  <div style={{ width: "87%" }}>
                    {" "}
                    <span
                      style={{
                        color: "#394F65",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                    >
                      ¿Pierde el equilibrio por mareos, o ha perdido alguna vez
                      el conocimiento?
                    </span>
                  </div>
                  <div style={{ width: "13%" }}>
                    <button
                      style={{
                        width: "100%",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                      className={`d-flex ${userTriage?.health_safe_balance
                        ? " add_location "
                        : " add_location_negation "
                        }  py-1`}
                    >
                      {userTriage?.health_safe_balance ? "SI" : "NO"}
                    </button>
                  </div>
                </div>
                <div className="d-flex w-100 align-items-center gap-2">
                  <div style={{ width: "87%" }}>
                    {" "}
                    <span
                      style={{
                        color: "#394F65",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                    >
                      ¿Tiene problema en algún hueso o articulación que pueda
                      ser agravado por un cambio en su actividad física?
                    </span>
                  </div>
                  <div style={{ width: "13%" }}>
                    <button
                      style={{
                        width: "100%",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                      className={`d-flex ${userTriage?.health_safe_bones
                        ? " add_location "
                        : " add_location_negation "
                        }  py-1`}
                    >
                      {userTriage?.health_safe_bones ? "SI" : "NO"}
                    </button>
                  </div>
                </div>
                <div className="d-flex w-100 align-items-center gap-2">
                  <div style={{ width: "87%" }}>
                    {" "}
                    <span
                      style={{
                        color: "#394F65",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                    >
                      ¿Está tomando medicamentos recetados por el médico para la
                      presión arterial o para el corazón (por ejemplo, pastillas
                      diuréticas)?
                    </span>
                  </div>
                  <div style={{ width: "13%" }}>
                    <button
                      style={{
                        width: "100%",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                      className={`d-flex ${userTriage?.health_safe_medicated
                        ? " add_location "
                        : " add_location_negation "
                        }  py-1`}
                    >
                      {userTriage?.health_safe_medicated ? "SI" : "NO"}
                    </button>
                  </div>
                </div>
                <div className="d-flex w-100 align-items-center gap-2">
                  <div style={{ width: "87%" }}>
                    {" "}
                    <span
                      style={{
                        color: "#394F65",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                    >
                      ¿Sabe de cualquier otra razón en contra de que ejercite?
                    </span>
                  </div>
                  <div style={{ width: "13%" }}>
                    <button
                      style={{
                        width: "100%",
                        fontSize: "calc(.45rem + .45vw)",
                      }}
                      className={`d-flex ${userTriage?.health_safe_other
                        ? " add_location "
                        : " add_location_negation "
                        }  py-1`}
                    >
                      {userTriage?.health_safe_other ? "SI" : "NO"}
                    </button>
                  </div>
                </div>
              </div>
            </PerfectScrollbar>
            <div className="d-flex w-100 mt-4">
              {" "}
              <button
                style={{
                  marginRight: "4%",
                  fontSize: "calc(.45rem + .45vw)",
                  marginLeft: "auto",
                }}
                className="  d-flex add_location px-5 py-1"
                onClick={generatePdfTriage}
              >
                Descargar
              </button>
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-center flex-column p-3">
            <div
              style={{ justifyContent: "flex-start", marginRight: "auto" }}
              className="d-flex align-items-center"
            >
              <div>
                <ButtonArrow
                  classes="btnBackPr me-1"
                  colorBack={`var(--elevvaArrowColor)`}
                  handleClick={() => setStepUser(1)}
                />
              </div>
              <span className="ms-1" style={{ color: "#395056" }}>
                Contrato de exclusión, consentimiento informado y manejo de datos
              </span>
            </div>

            <PerfectScrollbar
              className="ps-5"
              style={{ maxHeight: "calc(100vh - 28rem)" }}
            >
              <div>
                <span style={{ color: "#9DACBD", fontSize: "calc(.45rem + .45vw)" }}>
                  <strong>
                    CONTRATO ÚNICO DE EXCLUSIÓN DE RESPONSABILIDAD, CONSENTIMIENTO
                    INFORMADO Y MANEJO DE DATOS
                  </strong>
                  <br />
                  <br />
                  Entre:{" "}
                  <span style={{ textTransform: "uppercase" }}>
                    {detailCompany?.name}
                  </span>
                  , identificado con NIT {detailCompany?.nit || "__________"}, en
                  adelante el “GIMNASIO”, y{" "}
                  <span style={{ textTransform: "uppercase" }}>
                    {userDetail?.full_name}
                  </span>
                  , identificado con {userDetail?.document || "__________"}, en adelante
                  el “USUARIO”, se celebra el presente Contrato de Exclusión de
                  Responsabilidad, Consentimiento Informado y Manejo de Datos, bajo las
                  siguientes cláusulas:
                  <br />
                  <br />
                  <strong>PRIMERA. – Objeto</strong>
                  <br />
                  El presente contrato tiene por objeto establecer los términos y
                  condiciones bajo los cuales el USUARIO participa en las actividades
                  físicas, deportivas y recreativas ofrecidas por el GIMNASIO, así como
                  su consentimiento informado frente a los riesgos inherentes a dichas
                  actividades y la autorización para el tratamiento de sus datos
                  personales y sensibles.
                  <br />
                  <br />
                  <strong>SEGUNDA. – Aceptación y Asunción de Riesgos</strong>
                  <br />
                  El USUARIO declara haber sido informado de que toda actividad física o
                  deportiva implica riesgos inherentes, incluyendo, sin limitarse a:
                  lesiones musculares, esguinces, fracturas, desgarros, caídas, problemas
                  cardiovasculares o incluso la muerte súbita. El USUARIO acepta y asume
                  voluntariamente dichos riesgos, manifestando que participa de manera
                  libre, consciente y bajo su exclusiva responsabilidad. En
                  consecuencia, exonera de toda responsabilidad al GIMNASIO, sus
                  instructores, personal administrativo y demás colaboradores por
                  cualquier lesión, daño o perjuicio sufrido durante la práctica de
                  actividades físicas, salvo en los casos de dolo o culpa grave
                  demostrada por parte del GIMNASIO.
                  <br />
                  <br />
                  <strong>TERCERA. – Condiciones de Uso e Instrucciones</strong>
                  <br />
                  El USUARIO se compromete a:
                  <br />
                  <br />
                  Cumplir con las normas internas de seguridad, higiene y convivencia
                  del GIMNASIO.
                  <br />
                  <br />
                  Usar correctamente los equipos e instalaciones, de acuerdo con las
                  instrucciones brindadas por el personal autorizado.
                  <br />
                  <br />
                  Informar oportunamente sobre cualquier condición médica, dolor,
                  molestia o síntoma que pueda afectar su salud.
                  <br />
                  <br />
                  Abstenerse de participar bajo la influencia de alcohol, drogas o
                  sustancias psicoactivas.
                  <br />
                  <br />
                  El GIMNASIO no se hace responsable por accidentes o afectaciones
                  derivadas del incumplimiento de estas condiciones por parte del
                  USUARIO.
                  <br />
                  <br />
                  <strong>CUARTA. – Servicios Incluidos</strong>
                  <br />
                  El GIMNASIO pone a disposición del USUARIO:
                  <br />
                  <br />
                  Instalaciones y equipos en óptimas condiciones.
                  <br />
                  <br />
                  Profesionales capacitados en entrenamiento físico y acompañamiento
                  personalizado.
                  <br />
                  <br />
                  Servicios complementarios (nutrición, fisioterapia, valoración física,
                  entre otros) cuando así se pacten expresamente.
                  <br />
                  <br />
                  El USUARIO entiende que los servicios de entrenamiento personalizado o
                  acompañamiento externo que contrate fuera del GIMNASIO serán bajo su
                  propia responsabilidad.
                  <br />
                  <br />
                  <strong>QUINTA. – Pérdida o Daño de Objetos Personales</strong>
                  <br />
                  El GIMNASIO no se hace responsable por pérdida, hurto o daño de
                  objetos personales dentro o fuera de sus instalaciones.
                  <br />
                  <br />
                  <strong>SEXTA. – Políticas Comerciales</strong>
                  <br />
                  Los planes adquiridos son personales e intransferibles.
                  <br />
                  <br />
                  No se realiza devolución de dinero bajo ninguna circunstancia.
                  <br />
                  <br />
                  En caso de incapacidad médica temporal o permanente, o condiciones
                  especiales (como embarazo), el USUARIO podrá solicitar la suspensión
                  temporal o cesión del plan, sin derecho a reembolso del tiempo ya
                  utilizado.
                  <br />
                  <br />
                  No se realizan congelaciones ni prórrogas en planes promocionales salvo
                  pacto expreso.
                  <br />
                  <br />
                  <strong>SÉPTIMA. – Cláusula de Indemnidad</strong>
                  <br />
                  El USUARIO se obliga a mantener indemne al GIMNASIO frente a cualquier
                  reclamación o gasto derivado de daños causados a terceros o a las
                  instalaciones como resultado de su conducta durante la práctica de
                  actividades físicas.
                  <br />
                  <br />
                  <strong>OCTAVA. – Derechos de Imagen</strong>
                  <br />
                  El USUARIO autoriza expresamente al GIMNASIO a tomar fotografías o
                  videos durante su participación en actividades dentro de las
                  instalaciones, con fines informativos o promocionales (redes sociales,
                  sitio web o material publicitario), sin derecho a compensación
                  económica o aprobación previa del material.
                  <br />
                  <br />
                  <strong>NOVENA. – Autorización para el Tratamiento de Datos
                    Personales y Sensibles</strong>
                  <br />
                  El USUARIO autoriza de manera expresa al GIMNASIO y a la plataforma
                  tecnológica ELEVVA, a recolectar, almacenar, procesar y compartir sus
                  datos personales y sensibles, incluyendo pero no limitándose a:
                  nombre, edad, estado de salud, composición corporal, rendimiento
                  deportivo, historial de entrenamiento y progreso físico.
                  <br />
                  <br />
                  Estos datos podrán ser usados con el fin de:
                  <br />
                  <br />
                  Personalizar y optimizar los programas de entrenamiento.
                  <br />
                  <br />
                  Monitorear la evolución física del USUARIO.
                  <br />
                  <br />
                  Gestionar servicios, comunicaciones y actividades internas del
                  GIMNASIO.
                  <br />
                  <br />
                  Cumplir con obligaciones legales y contractuales.
                  <br />
                  <br />
                  El GIMNASIO y ELEVVA garantizan el tratamiento confidencial y seguro
                  de la información, conforme a la Ley 1581 de 2012 y demás normas
                  vigentes sobre protección de datos personales. El USUARIO podrá
                  solicitar en cualquier momento la actualización, corrección o
                  eliminación de su información.
                  <br />
                  <br />
                  <strong>DÉCIMA. – Aceptación de Términos y Condiciones de la
                    Plataforma ELEVVA</strong>
                  <br />
                  El USUARIO declara que ha leído y acepta los Términos y Condiciones de
                  uso y la Política de Privacidad de la plataforma ELEVVA, disponibles
                  en:
                  <br />
                  <br />
                  <a
                    href="https://elevva.com.co/terminos-y-condiciones/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://elevva.com.co/terminos-y-condiciones/
                  </a>
                  <br />
                  <a
                    href="https://elevva.com.co/politica-privacidad/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://elevva.com.co/politica-privacidad/
                  </a>
                  <br />
                  <br />
                  El USUARIO entiende y acepta que:
                  <br />
                  <br />
                  Es responsable de la veracidad y actualización de sus datos.
                  <br />
                  <br />
                  ELEVVA podrá actualizar sus políticas y condiciones, debiendo el
                  USUARIO revisarlas periódicamente.
                  <br />
                  <br />
                  La aceptación digital (mediante botón “Siguiente”, firma electrónica o
                  similar) constituye plena validez jurídica del presente contrato.
                  <br />
                  <br />
                  <strong>DÉCIMA PRIMERA. – Vigencia</strong>
                  <br />
                  El presente contrato entra en vigencia desde su firma (o aceptación
                  digital) y permanecerá activo durante todo el tiempo que el USUARIO
                  utilice los servicios o instalaciones del GIMNASIO, sin perjuicio de
                  su renovación o terminación conforme a las políticas internas.
                  <br />
                  <br />
                  <strong>DÉCIMA SEGUNDA. – Declaración Final</strong>
                  <br />
                  El USUARIO declara haber leído, entendido y aceptado en su totalidad
                  el presente contrato, firmando libre y voluntariamente, sin error, dolo
                  ni coacción alguna.
                </span>
              </div>
            </PerfectScrollbar>

            <div className="d-flex w-100 mt-4">
              <button
                style={{
                  marginRight: "2%",
                  fontSize: "calc(.45rem + .45vw)",
                  marginLeft: "auto",
                }}
                className="d-flex add_location px-4 py-1"
                onClick={generatePdf}
              >
                Descargar
              </button>
            </div>
          </div>
        )
      ) : (
        <div>
          <div
            className={`d-flex justify-content-center  align-items-center mx-auto ${laptopMax1350.matches ? "my-3 px-1" : "my-3 px-3"
              } `}
          >
            <div
              style={{
                lineHeight: "1",
                width: laptop1600.matches ? "30%" : "20%",
              }}
            >
              <span
                style={{
                  fontSize: laptop1600.matches
                    ? "calc(.5rem + .5vw)"
                    : "calc(.4rem + .4vw)",
                }}
              >
                Administración de usuarios
              </span>
            </div>
            <div
              className={`d-flex  align-items-center w-100 mx-auto ${laptop1600.matches ? " gap-4 " : " gap-2 "
                }  justify-content-end`}
            >
              {" "}
              <div className="cursor-pointer" onClick={handlerTags}>
                <TagIcon />
              </div>
              <div className="cursor-pointer">
                <button
                  style={{ padding: "0.4rem" }}
                  className="  d-flex add_location w-100"
                  onClick={getUsers}
                >
                  {" "}
                  <ReloadIcon />
                </button>
              </div>
              <button
                style={{ padding: "0.6rem 1rem", lineHeight: "1" }}
                className="  d-flex add_location "
                onClick={() => setShowModalPreRegister(true)}
              >
                Preregistrar Usuario
              </button>
              <button
                style={{ padding: "0.6rem 1rem", lineHeight: "1" }}
                className="  d-flex add_location  "
                onClick={handleDeleteUser}
              >
                Eliminar usuario
              </button>
              <button
                style={{ padding: "0.6rem 1rem", lineHeight: "1" }}
                className="  d-flex add_location "
                onClick={handleDownloadExcel}
              >
                Descargar Base de datos{" "}
              </button>
            </div>
          </div>
          <div className="d-flex  gap-2 pe-3 align-items-center ">
            <div style={{ position: "relative" }}>
              <input
                placeholder="Buscar usuario"
                type="search"
                className="searchUsers "
                style={{
                  border: "1px solid var(--elevvaTextSubtitle)",
                  borderRadius: "20px",
                  fontSize: "calc(.33rem + .32vw)",
                  padding: "0.4rem 1rem",
                }}
                onChange={searchUsers}
              ></input>
              <span className="search-icon-admin">
                <SearchIconAlone fontSize={10} />
              </span>
            </div>
            {/* <div className="d-flex align-items-center me-1">
              <FiltersTable
                style={{ width: "100%", padding: "2%" }}
                className="cursor-pointer"
                onClick={filtersUser}
              />
            </div> */}
            <div className="d-flex align-items-center my-2 gap-2 px-2">
              <button
                style={{
                  padding: "0.5rem 0.7rem",
                  lineHeight: "1",
                  background: optionFilter === "" ? "#394F65" : "white",
                }}
                className="  d-flex add_location "
                onClick={() => {
                  getUsers();
                  setOptionFilter("");
                }}
              >
                <div
                  className="d-flex align-items-center "
                  style={{ color: optionFilter === "" ? "white" : "#394F65" }}
                >
                  <span className="d-flex align-items-center my-auto text-center">
                    {" "}
                    <img
                      width={12}
                      height={12}
                      src={"/assets/person-service-white.svg"}
                      alt={"payment"}
                    />
                  </span>
                  <span
                    className="mx-1 my-auto text-center"
                    style={{
                      fontWeight: "bold",
                      fontSize: "calc(.4rem + .4vw)",
                    }}
                  >
                    {detailCompany ? detailCompany.active_users : 0}
                  </span>
                  <span style={{ fontSize: "calc(.33rem + .32vw)" }}>
                    Usuarios vigentes
                  </span>
                </div>
              </button>
              <button
                style={{
                  padding: "0.5rem 0.7rem",
                  lineHeight: "1",
                  background: "white",
                }}
                className="  d-flex add_location "
                onClick={() => { }}
              >
                <div className="d-flex align-items-center ">
                  <div
                    className="d-flex align-items-center"
                    onClick={() => {
                      props.setShowPreRegisteredUsersList(true);
                    }}
                  >
                    <span
                      className="mx-1 my-auto text-center"
                      style={{
                        color:
                          detailCompany &&
                            detailCompany.pre_register_members &&
                            detailCompany.pre_register_members > 0
                            ? "red"
                            : "#394F65",
                        fontWeight: "bold",
                        fontSize: "calc(.4rem + .4vw)",
                      }}
                    >
                      {detailCompany &&
                        detailCompany.pre_register_members &&
                        detailCompany.pre_register_members > 0
                        ? detailCompany.pre_register_members
                        : "---"}
                    </span>
                    <span
                      style={{
                        fontSize: "calc(.33rem + .32vw)",
                        color: "#394F65",
                      }}
                    >
                      Usuarios por crear cuenta
                    </span>
                  </div>
                </div>
              </button>
              <button
                style={{
                  padding: "0.5rem 0.7rem",
                  lineHeight: "1",
                  background:
                    optionFilter === "birthday" ? "rgb(57, 79, 101)" : "white",
                }}
                className="  d-flex add_location "
                onClick={() => showBirthDay()}
              >
                <div className="d-flex align-items-center ">
                  <span
                    className="mx-1 my-auto text-center"
                    style={{
                      color:
                        detailCompany &&
                          detailCompany.pre_register_members &&
                          detailCompany.pre_register_members > 0
                          ? "red"
                          : "#394F65",
                      fontWeight: "bold",
                      fontSize: "calc(.4rem + .4vw)",
                    }}
                  >
                    {detailCompany &&
                      detailCompany.birthday_users &&
                      detailCompany.birthday_users > 0
                      ? detailCompany.birthday_users
                      : "---"}
                  </span>
                  <span
                    style={{
                      fontSize: "calc(.33rem + .32vw)",
                      color: optionFilter === "birthday" ? "white" : "#394F65",
                    }}
                  >
                    Próximos cumpleaños
                  </span>
                </div>
              </button>
              <div
                style={{
                  lineHeight: "1",
                  background: "white",
                  position: "relative",
                }}
              >
                <button
                  style={{
                    padding: "0.4rem 0.7rem",
                    lineHeight: "1",
                    background: "white",
                  }}
                  className="  d-flex add_location "
                  onClick={() => { }}
                >
                  <div className="d-flex align-items-center ">
                    <div
                      className="d-flex align-items-center gap-1 "
                      onClick={() =>
                        modalFilters ? setModalFilters(null) : filtersUser()
                      }
                    >
                      <span
                        style={{
                          fontSize: "calc(.33rem + .32vw)",
                          color: "#394F65",
                        }}
                      >
                        Etiquetas
                      </span>
                      <span>
                        <ArrowDown width={12} height={12}></ArrowDown>
                      </span>
                    </div>
                  </div>
                </button>
                {modalFilters}
              </div>
            </div>
          </div>

          <div className={laptopMax1350.matches ? "p-1" : "p-3"}>
            <div style={{ width: "100%" }}>
              <PerfectScrollbar
                style={{
                  maxHeight: getResponsiveMaxHeight(),
                  overflowY: "scroll",
                }}
              >
                <table style={{ width: "100%" }}>
                  <thead
                    className="size-table-users"
                    style={{
                      width: "100%",
                      overflow: "scroll",
                      position: "sticky",
                      top: "0",
                      backgroundColor: "white",
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          fontWeight: "normal",
                          width: "22%",
                        }}
                      >
                        <div className="d-flex gap-2 align-items-center">
                          <label className="custom-checkbox">
                            <input
                              type="checkbox"
                              name="userAll"
                              onClick={(e) => {
                                let checkedAll = e.target.checked;
                                if (checkedAll) {
                                  setUserSelected(users.map((user) => user.user_id));
                                } else {
                                  setUserSelected([]);
                                }
                              }}
                            />
                            <span className="checkmark"></span>
                          </label>
                          <span className="size-table-users">Nombre</span>
                        </div>
                      </th>
                      <th
                        style={{
                          fontWeight: "normal",
                          width: "20%",
                        }}
                      >
                        Correo Electrónico
                      </th>
                      <th
                        style={{
                          fontWeight: "normal",
                          width: "8%",
                        }}
                      >
                        Cumpleaños
                      </th>
                      <th
                        style={{
                          fontWeight: "normal",
                          width: "15%",
                          textAlign: "center"
                        }}
                      >
                        Etiqueta
                      </th>
                      <th
                        style={{
                          fontWeight: "normal",
                          width: "17%",
                        }}
                      >
                        Membresía
                      </th>
                      <th
                        style={{
                          fontWeight: "normal",
                          width: "8%",
                        }}
                      >
                        Vencimiento
                      </th>
                      <th
                        style={{
                          width: "10%",
                          textAlign: "center",
                          fontWeight: "normal",
                        }}
                      >
                        {/*Detalles / Eliminar*/}
                      </th>
                    </tr>
                  </thead>

                  <tbody className="w-100">
                    {users.length > 0 &&
                      users.map((user) => (
                        <tr
                          key={user.user_id}
                          className="size-table-users"
                          style={{
                            borderBottom: "1px solid #A8C2D7",
                            color: "#394F65",
                          }}
                        >
                          {/* Nombre */}
                          <td
                            style={{ width: "22%" }}
                            className="flex gap-2 align-items-center justify-content-center py-3"
                          >
                            <div className="d-flex gap-2 align-items-center ">
                              <label className="custom-checkbox">
                                <input
                                  type="checkbox"
                                  name="user"
                                  checked={userSelected.includes(user.user_id)}
                                  onClick={() =>
                                    setUserSelected((prev) => {
                                      if (prev.includes(user.user_id)) {
                                        return prev.filter((item) => item !== user.user_id);
                                      }
                                      return [...prev, user.user_id];
                                    })
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                              <div className="size-table-users">{user.full_name}</div>
                            </div>
                          </td>

                          {/* Correo */}
                          <td style={{ width: "20%" }}>{user.email}</td>

                          {/* Cumpleaños */}
                          <td
                            className="align-items-center"
                            style={{
                              width: "8%",
                              color: isBirthdayToday(user?.birthday) ? "red" : "#394F65",
                            }}
                          >
                            {isBirthdayToday(user?.birthday) && <BirthdayIcon />}{" "}
                            {user?.birthday ? moment(user?.birthday)?.format("DD-MMM") : "---"}
                          </td>

                          {/* Etiqueta */}
                          <td style={{ width: "15%", textAlign: "center" }}>
                            {user.tags.length > 0
                              ? user.tags.map((e) => e.name).join(", ")
                              : "----"}
                          </td>

                          {/* Membresía */}
                          <td style={{ width: "17%" }}>
                            <div className="d-flex align-items-center gap-2">
                              <div onClick={() => editMembershipClient(user.user_id)}>
                                <EditIcon
                                  className="cursor-pointer"
                                  width={"20px"}
                                  height={"20px"}
                                />
                              </div>
                              <div style={{ lineHeight: "1" }}>
                                <span className="size-table-users">
                                  {user.membership_name}
                                </span>
                              </div>
                            </div>
                          </td>

                          {/* Vencimiento */}
                          <td style={{ width: "8%" }}>
                            {user.end_date
                              ? moment(user.end_date)?.format("DD-MMM-YY")
                              : "---"}
                          </td>

                          {/* Acciones */}
                          <td style={{ width: "10%", textAlign: "center" }} className="">
                            <button
                              onClick={() => setUserDetail(user)}
                              className="px-1"
                              style={{
                                border: "none",
                                background: "transparent",
                              }}
                            >
                              <SearchInvidual />
                            </button>
                            <button
                              className="btn btn-link p-0 px-1"
                              onClick={() => {
                                setUserToDelete(user?.user_id);
                                setShowDeleteModal(true);
                              }}
                              disabled={userToDelete === user?.user_id}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                <path d="M10.9836 17.0621H3.91968C3.87231 17.0507 3.82556 17.0356 3.77747 17.0284C3.03772 16.9196 2.45459 16.5732 2.13599 15.8788C2.00586 15.5952 1.90417 15.2845 1.86353 14.9763C1.6897 13.6566 1.54297 12.3334 1.38721 11.0112C1.2583 9.91498 1.13025 8.81854 1.00244 7.72211C0.934937 7.14429 0.86853 6.56641 0.800781 5.98047H14.2368C14.1013 7.11145 13.9675 8.22913 13.8334 9.3468C13.6946 10.5034 13.5581 11.6602 13.4153 12.8162C13.3202 13.5866 13.2476 14.3618 13.1069 15.1241C12.9407 16.0284 12.4436 16.6876 11.5173 16.9485C11.3428 16.9978 11.1617 17.0249 10.9836 17.0621ZM7.01709 11.4003C7.01709 11.5445 7.01709 11.6887 7.01709 11.8329C7.01709 12.6982 7.01514 13.5634 7.01855 14.4287C7.01953 14.7013 7.21863 14.9105 7.47791 14.9298C7.73071 14.9486 7.95813 14.7763 8.00793 14.5221C8.02051 14.4576 8.01746 14.3897 8.01746 14.3232C8.01794 12.3709 8.01794 10.4185 8.01782 8.46613C8.01782 8.4162 8.02014 8.36597 8.01538 8.31647C7.9895 8.03741 7.75977 7.84198 7.48083 7.85944C7.20874 7.8764 7.01807 8.09045 7.01782 8.38849C7.01611 9.39252 7.01709 10.3964 7.01709 11.4003ZM5.26929 11.3817C5.26929 10.4213 5.26953 9.46088 5.26892 8.50049C5.26892 8.42853 5.26929 8.35571 5.25928 8.28461C5.22314 8.02576 5.00903 7.84918 4.74829 7.8584C4.46851 7.86829 4.26831 8.08014 4.26782 8.39081C4.26514 10.3948 4.26636 12.3989 4.26746 14.403C4.26758 14.4579 4.27527 14.5144 4.28943 14.5674C4.34814 14.7869 4.55994 14.9391 4.78833 14.9302C5.0177 14.9214 5.21509 14.7546 5.25488 14.5283C5.26807 14.4525 5.26855 14.3737 5.26855 14.2962C5.26953 13.3247 5.26929 12.3532 5.26929 11.3817ZM9.76733 11.3882C9.76733 12.3597 9.76721 13.3313 9.76794 14.3028C9.76794 14.3747 9.76831 14.4478 9.77979 14.5184C9.81812 14.7529 10.0188 14.9244 10.2546 14.9304C10.4915 14.9364 10.7024 14.7761 10.751 14.5446C10.7677 14.4641 10.7698 14.3793 10.7698 14.2964C10.7708 12.3591 10.7706 10.4216 10.77 8.48419C10.7698 8.41223 10.7688 8.33923 10.7566 8.26874C10.7129 8.0166 10.5034 7.84967 10.2488 7.85834C9.95728 7.86829 9.7688 8.08612 9.76819 8.42389C9.76636 9.41199 9.76746 10.4001 9.76733 11.3882Z" fill="#B5C1CD" />
                                <path d="M3.41725 2.1355C3.55019 1.71277 3.63649 1.31354 3.79933 0.94873C4.08327 0.313476 4.58791 -0.00433412 5.30348 0.0019525C6.71364 0.0141595 8.12429 0.0206293 9.53395 0.000243515C10.4588 -0.0131842 10.9289 0.530761 11.1431 1.12225C11.2404 1.39093 11.2843 1.67914 11.3513 1.95868C11.3642 2.01184 11.3721 2.06622 11.385 2.13483C11.8919 2.13483 12.3914 2.12006 12.8897 2.13849C13.5418 2.16247 14.0911 2.42725 14.5235 2.91955C14.9236 3.37506 15.0674 3.91449 15.022 4.50983C15.0027 4.76361 14.8091 4.94653 14.5524 4.96637C14.4971 4.97064 14.4413 4.96814 14.3858 4.96814C9.80544 4.96832 5.22512 4.96832 0.644915 4.9682C0.175311 4.9682 0.00722007 4.7926 0.000262066 4.32635C-0.0191471 3.04163 1.04274 2.18127 2.12538 2.13837C2.56813 2.12085 3.01198 2.1355 3.41725 2.1355ZM10.3594 2.12408C10.325 1.80292 10.2634 1.51306 10.0943 1.25616C9.98586 1.09161 9.834 1.00574 9.63332 1.0058C8.16164 1.00671 6.6902 1.00677 5.21877 1.00561C5.04457 1.00549 4.90407 1.07129 4.80019 1.20721C4.59487 1.47583 4.53688 1.79297 4.4905 2.12408H10.3594Z" fill="#B5C1CD" />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </PerfectScrollbar>
              <div className="d-flex justify-content-end align-items-center gap-3 mt-2">
                <span>
                  {Math.min((page - 1) * 10 + 1, count)} -{" "}
                  {Math.min(page * 10, count)} de {count}
                </span>
                <div
                  onClick={page > 1 ? () => changePage("previous") : undefined}
                  className={`cursor-pointer ${page > 1 ? "text-black" : "text-gray-400 cursor-not-allowed"
                    }`}
                >
                  <ArrowLeft />
                </div>
                <div
                  onClick={
                    page * 10 < count ? () => changePage("next") : undefined
                  }
                  className={`cursor-pointer ${page * 10 < count
                    ? "text-black"
                    : "text-gray-400 cursor-not-allowed"
                    }`}
                >
                  <ArrowRight />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAdmin;
